const radius = {
  sm: '3px',
  md: '4px',
  lg: '26px',
  full: '9999px'
};
const primary = '#2d2f2f';
export const defaultTheme = {
  colors: {
    primary,
    danger: '#e5453d',
    warning: '#f5a623',
    success: '#00a28b',
    info: '#0091ae',
    text: '#33475b',
    textSecondary: '#516f90',
    textMuted: '#99acc2',
    textDisabled: '#767676',
    buttonDisabledBackground: '#888888',
    // disabled components are exempt from contrast (WCAG 1.4.3); 3.56:1 with white provides a visible inactive state
    border: '#cbd6e2',
    borderLight: '#e5e8eb',
    background: '#fff',
    focus: primary
  },
  radius,
  fontSizes: {
    xs: '11px',
    sm: '12px',
    md: '13px',
    lg: '14px',
    xl: '18px',
    xxl: '22px'
  },
  fontWeights: {
    normal: 400,
    bold: 700
  },
  spacing: {
    '100': '4px',
    '200': '8px',
    '300': '16px',
    '400': '32px'
  },
  // Component tokens reference the scales above so values live in one place.
  components: {
    button: {
      borderRadius: radius.full
    },
    select: {
      borderRadius: radius.full,
      textPaddingLeft: '10px'
    },
    slotList: {
      borderRadius: radius.full
    }
  }
};